import axios from "axios";

const WORDPRESS_BASE_URL =
  process.env.REACT_APP_WEBSITE_URL || "https://www.bookdoc.com";

const stripShortcodes = (html) => (html || "").replace(/\[\/?vc_[^\]]*\]/g, "");

class WordPressPageService {
  content(slug) {
    return axios
      .get(`${WORDPRESS_BASE_URL}/wp-json/wp/v2/pages`, {
        params: { slug: slug, _fields: "content" },
      })
      .then((response) => {
        const page = response.data && response.data[0];
        if (!page) {
          throw new Error(`WordPress page not found for slug: ${slug}`);
        }
        return stripShortcodes(page.content.rendered);
      });
  }
}

export default new WordPressPageService();
